import * as React from 'react';
import { } from 'react-dom';
import { useSelector } from 'react-redux';
import { Link, Prompt, useHistory, useLocation } from 'react-router-dom';
import {
    Col,
    Collapse,
    Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Navbar,
    NavbarBrand, NavbarToggler, Row
} from 'reactstrap';
import Swal from 'sweetalert2';
import { useAppDispatch, useAppSelector } from '../../../hooks/index';
import CFO_INGOGLIA from '../../../images/cfo-ingoglia-seal.png';
import { Afr, commitAfr, getSelectedAfr, getVersionPropertiesChanged } from '../../../redux/AfrSlice';
import { resetConceptState } from '../../../redux/ConceptSlice';
import { isDirty, setIsDirty } from '../../../redux/MiscSlice';
import { UserRoleEnum, selectUser } from '../../../redux/UserSlice';
import { environmentBanner } from '../../../utils/AppSettings';
import userManager from '../../../utils/userManager';
import utilityHelper from '../../../utils/utilityHelper';
import './NavMenu.css';

const NavMenu = () => {

    const [dropdownOpen, setDropdownOpen] = React.useState(false);
    const toggle = () => setDropdownOpen(prevState => !prevState);
    const userData = useSelector(selectUser);
    const dispatch = useAppDispatch();
    const isDirtyInfo: boolean = useAppSelector(isDirty);
    const currentLocation = useLocation();
    const history = useHistory();
    const selected: Afr | null = useAppSelector(getSelectedAfr);
    const stateChanges = useAppSelector(getVersionPropertiesChanged);

    const [logout, setLogout] = React.useState(true);
    const [logoutClicked, setLogoutClicked] = React.useState(false);


    const onLogoutButtonClick = (event: React.MouseEvent<any, MouseEvent>) => {

        /* The event click was moved into an effect because the clousures.
         * The "logout" variable has the value out of sync when the code reaches this function,
         * that is the reason because the original code was moved into the effect.
         * the same work was achieved using 2 state variables: logout and logoutClicked.
         */
        event.preventDefault();
        setLogoutClicked(true);

    }

    function handleBlockedRoute(nextLocation: any) {

        if (utilityHelper.isBlockedNavigation(nextLocation.pathname, isDirtyInfo)) {
            Swal.fire({
                title: '<b>Are you sure?</b>',
                html: "There are unsaved changes to your AFR. Do you want to <b>discard</b> your changes? <br/> You won't be able to revert this!",
                icon: 'warning',
                allowOutsideClick: false,
                showCancelButton: true,
                showDenyButton: true,
                confirmButtonColor: '#3085d6',
                denyButtonColor: '#28a745',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, discard it!',
                cancelButtonText: 'No, cancel!',
                denyButtonText: 'Save and Close!',
                reverseButtons: true
            }).then((result: any) => {
       
                if (result.isConfirmed) {

                    //reset the dirty flag so the save/undo buttons disappear
                    dispatch(setIsDirty({ IsDirty: false, Page: "" }));

                    history.push(nextLocation.pathname);
                    setLogout(true);

                    return true;

                } else {
                    setLogout(false);

                    if (result.isDenied) {

                        var commitCall = {
                            currentAfr: selected,
                            changedVersionStates: stateChanges,
                            submit: false
                        }
                        dispatch(commitAfr(commitCall));
                        dispatch(resetConceptState({}));

                        //reset the dirty flag
                        dispatch(setIsDirty({ IsDirty: false, Page: "" }));

                        Swal.fire('Changes saved!', '', 'info');
                        history.push(nextLocation.pathname);
                    }
                    return false;
                }

            });

            //return back to the previous location
            history.push(currentLocation.pathname);
            setLogout(false);
            return false;

        } else {
            setLogout(true);
            return true;
        }
    }

    /* This is the original : onLogoutButtonClick */
    React.useEffect(function () {

        if (logout && logoutClicked) {
            userManager.signoutRedirect();
        }
    }, [logoutClicked]);

     
    return (
        <Row className="NavMenu" >
            <Col>
                <Prompt when={true} message={handleBlockedRoute} />

                <Navbar dark>
                    {/*TODO: change this to use a Link component so that the base url is automatically attached*/
                     /* Alex said: I implemented "<Link/>" to allow that everything pass thru the Router  */ }
                    
                        <NavbarBrand>
                            <Row>
                                <Col>
                                <img className="m-3 cfoLogo" src={CFO_INGOGLIA} />
                                </Col>
                                { /*I just put a font style here because it looked like the header was applying
                                    two different fonts.  The font and styling can be addressed later*/}
                                <Col style={{ fontFamily: "sans-serif" }} className="align-self-center" >
                                    <Row>
                                        <Col>
                                            <div >
                                                <h3>DEPARTMENT OF FINANCIAL SERVICES</h3>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Collapse isOpen={(`${environmentBanner}`).length > 0} className="d-flex align-items-center">
                                    <Col >
                                        <div >
                                            <h3 >{`${environmentBanner}`}</h3>
                                        </div>                                                                         
                                    </Col>
                                </Collapse>
                            </Row>
                        </NavbarBrand>
                    
                   
                    {userData != null &&
                        userData.userProfile != null ? userData.userProfile.role == UserRoleEnum.Admin ? (
                            <span className="ml-auto">

                                <NavbarToggler onClick={toggle}
                                    style={{
                                        marginLeft: '4em',

                                    }} />

                                <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                                    <DropdownToggle style={{
                                        visibility: 'hidden'
                                    }}>

                                    </DropdownToggle>
                                    <DropdownMenu onMouseLeave={toggle}>
                                        <DropdownItem>
                                            <Link to="/AdminMenu">Main Menu</Link>
                                        </DropdownItem>
                                        <DropdownItem>
                                            <Link to="/PublicReportsMenu">Public Reports</Link>
                                        </DropdownItem>
                                        <DropdownItem onClick={onLogoutButtonClick}>
                                            <Link to="/SignoutCallback">Logout</Link>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </span>
                        ) : (
                        <span className="ml-auto">
                            <NavbarToggler onClick={toggle}
                                style={{
                                    marginLeft: '2em',
                                }} />
                            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                                <DropdownToggle style={{
                                    visibility: 'hidden'
                                }}>
                                </DropdownToggle>
                                <DropdownMenu onMouseLeave={toggle}>
                                    <DropdownItem>
                                        <Link to="/EntityMenu">Main Menu</Link>
                                    </DropdownItem>
                                    <DropdownItem>
                                        <Link to="/PublicReportsMenu">Public Reports</Link>
                                    </DropdownItem>
                                    <DropdownItem onClick={onLogoutButtonClick}>
                                        <Link to="/SignoutCallback">Logout</Link>
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </span>

                    ) :
                        (<span>
                            <NavbarToggler onClick={toggle}
                                style={{
                                    marginLeft: '2em',
                                    visibility: 'hidden',
                                }} />
                        </span>)}
                </Navbar>
            </Col>
        </Row>
    );
}

export default NavMenu;

